<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <TheTemplateH v-if="giveData.give_details" heading="ポイント詳細">
          <template #title>{{ title }}</template>

          <template #header-label>
            <TextLabel
              v-if="approvalEnabled && approved === 'approved'"
              :color="{ border: '#616161', content: '#ffffff' }"
              :reverse="false"
              >{{ approvedLabel }}</TextLabel
            >
          </template>
          <template #contents>
            <div class="p-the-h03">
              <TheHDetail :image="true" :usage-point="givePoint">
                <template #image>
                  <HGivePointPageIcon
                    v-if="point.state === 'give'"
                    :from="userIcon"
                    :to="image"
                  />
                  <IconUserImage
                    v-else-if="point.state === 'given'"
                    :size="userImageSize"
                  >
                    <img :src="image" alt />
                  </IconUserImage>
                </template>

                <template #header>
                  <div class="p-the-h03-detail">
                    <SmallText>
                      {{ giveData.give_details.give_id.label }}
                      &ensp;{{ giveData.give_details.give_id.id }}
                    </SmallText>

                    <HContainer margin-size="xs">
                      <template #content>
                        <span class="p-the-h03-detail__text" data-translate-skip>
                          {{ giveDetails.give_to }}
                        </span>
                      </template>
                    </HContainer>

                    <HContainer margin-size="xs">
                      <template #content>
                        <SmallText data-translate-skip>{{
                          giveDetails.group_name
                        }}</SmallText>
                      </template>
                    </HContainer>

                    <!-- DX_IC-628 グループコード表示追加 -->
                    <HContainer margin-size="xs">
                      <template #content>
                        <SmallText>ID：{{ giveDetails.group_code }}</SmallText>
                      </template>
                    </HContainer>
                  </div>
                </template>

                <template #body>
                  <HContainer
                    v-if="giveData.giftBadgeInfo?.name"
                    margin-size="m"
                  >
                    <template #content>
                      <SmallText>バッジ</SmallText>
                      <div class="p-badge">
                        <img
                          :src="giveData.giftBadgeInfo.icon"
                          class="p-badge__icon"
                          alt=""
                        />
                        <span class="p-badge__name">
                          {{ giveData.giftBadgeInfo.name }}
                        </span>
                      </div>
                    </template>
                  </HContainer>
                  <HContainer margin-size="m">
                    <template #content>
                      <SmallText>タイトル</SmallText>
                      <span class="p-the-h03__text" data-translate-skip>{{
                        message.title
                      }}</span>
                    </template>
                  </HContainer>

                  <HContainer margin-size="m">
                    <template #content>
                      <SmallText>メッセージ</SmallText>
                      <p class="p-the-h03__text" data-translate-skip>
                        {{ message.text }}
                      </p>
                    </template>
                  </HContainer>

                  <HContainer margin-size="m">
                    <template v-if="messsageThreadEnabled" #content>
                      <ButtonMain
                        tag="a"
                        kind="secondary"
                        :reverse="true"
                        :href="message.url"
                      >
                        メッセージスレッドを見る
                      </ButtonMain>
                    </template>
                  </HContainer>

                  <HContainer margin-size="l">
                    <template #content>
                      <SmallText>{{ giveDetails.dateLabel }}</SmallText>
                      <p class="p-the-h03__text">
                        {{ giveDetails.date }}
                      </p>
                    </template>
                  </HContainer>
                </template>

                <template v-if="point.expiration" #point>
                  <SmallText
                    v-for="({ label, date }, key) in point.expiration"
                    :key="key"
                  >
                    {{ label }}&ensp;<span data-translate-skip>{{ date }}</span>
                  </SmallText>
                </template>
              </TheHDetail>
            </div>
          </template>
        </TheTemplateH>
      </div>
    </div>
    <FloatingGivePointButton />
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TheTemplateH from "@/general/components/templates/TheTemplateH.vue";
import TheHDetail from "@/general/components/pages/parts/PointHistoryList/layout/TheHDetail.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HGivePointPageIcon from "@/general/components/pages/parts/PointHistoryList/page-of-give-the-point/HGivePointPageIcon.vue";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { getTransactionThanksgivingDetail } from "@/general/store/api";
import {
  getQueryString,
  setQueryString
} from "@/common/assets/js/utils/queryParams";
import { formatUTCDate } from "@/common/assets/js/utils/dateFormat";
import { PointHistoryGiftInfo, UserInfo } from "@/general/store/models";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import { getApprovalStatusLabel } from "@/common/assets/js/utils/types";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";
import AuthApi from "@/general/api/authApi";

@Options({
  components: {
    TheHDetail,
    TextLabel,
    SmallText,
    IconUserImage,
    TheTemplateH,
    HContainer,
    HGivePointPageIcon
  }
})
export default class PointHistoryGift extends Vue {
  giveData: any = {};

  userInfo: UserInfo;

  avatar = "";
  statusCode = 10;
  get givePoint() {
    return {
      point: this.giveData.point.give,
      sign: this.giveData.point.added
    };
  }

  get userIcon() {
    //#59042対応によりセッション情報からavatarを取得するように修正
    //return this.userInfo?.avatar;
    return this.avatar;
  }

  async setPageData() {
    const breadcrumb = [
      {
        text: "",
        url: CONST_DATA.SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: "ポイント確認",
        url: `${CONST_DATA.SITE_MAP.POINT_CONFIRMATION}?${getQueryString({
          ...this.params,
          id: undefined
        })}`,
        pageType: "lower"
      },
      {
        text: " ポイント詳細",
        url: "",
        pageType: "lower"
      }
    ];

    await commons.getBreadcrumb(breadcrumb);
  }

  params = {
    id: "",
    transaction_direction: "",
    transaction_type: "",
    filter_position: "",
    refine_position: "",
    ordering: "",
    page: "1",
    search: ""
  };

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const queries = [
      { k: "id" },
      { k: "transaction_direction" },
      { k: "transaction_type" },
      { k: "filter_position" },
      { k: "refine_position" },
      { k: "ordering", v: "-created_at" },
      { k: "page", v: 1 },
      { k: "search" }
    ];

    this.params = setQueryString(this.params, queries);
    await this.setPageData();

    this.userInfo = auth.user;
    await this.retrieveGrantPointDetails(
      parseInt(this.params.id),
      this.params.transaction_direction
    );

    //#59042対応によりセッション情報からavatarを取得するように修正
    await AuthApi.getICSession()
      .then((result) => {
        const ic_session = JSON.parse(result);
        this.avatar = ic_session.avatar;
      })
      .catch(() => {
        this.avatar = "";
      });
  }

  async retrieveGrantPointDetails(id: number, transaction_direction: string) {
    const response: PointHistoryGiftInfo = await getTransactionThanksgivingDetail(
      id,
      transaction_direction
    );

    if (typeof response === "undefined" || response.status == "404") {
      window.location.href = "/error-not-found";
    }

    const { from_user, to_user } = response;

    const state = this.userInfo?.user_id === from_user.id ? "given" : "give";
    const added = state === "give" ? true : false;
    const user = state === "give" ? from_user : to_user;
    const title =
      state === "give"
        ? this.thanksPointName + "受贈"
        : this.thanksPointName + "贈与";

    const give_to = user?.last_name + " " + user?.first_name;

    let expirationList = [];
    if (response?.expiresList.length === 1) {
      let expirationTmp = {
        label: "有効期限",
        date: formatUTCDate(response?.expires_at)
      };
      expirationList.push(expirationTmp);
    } else {
      for (var i = 0; i < response?.expiresList.length; i++) {
        let expirationTmp = {
          label: "有効期限",
          date:
            formatUTCDate(response?.expiresList[i][0]) +
            "（" +
            response?.expiresList[i][1] +
            commons?.OrgPageSpecific?.point_name +
            "）"
        };
        expirationList.push(expirationTmp);
      }
    }

    // DX_IC-942
    this.giveData = {
      title,
      give_details: {
        image: user.id == 0 ? "" : user?.user_image,
        give_id: {
          label: "贈与ID",
          id: response?.pk
        },
        give_to,
        group_name: user?.group_name,
        // DX_IC-628 グループコード表示追加
        group_code: user?.group_code,
        message: {
          title: response?.title,
          text: response?.message,
          url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${state === "given" ? response?.to_user.id : response?.from_user.id}`
        },
        dateLabel: state === "given" ? "贈与日" : "受贈日",
        date: this.$dayjs
          .utc(
            response?.status === "approved"
              ? response?.approved_or_rejected_at
              : response?.created_at
          )
          .locale("ja")
          .format("YYYY/MM/DD")
      },
      approved: response?.status,
      point: {
        state,
        added,
        give: response?.points,
        expiration: expirationList
      },
      giftBadgeInfo: response?.giftBadgeInfo,
    };
    this.statusCode = response?.status_code;
    // DX_IC-942
    const messageArticleDetail = {
      id: user?.id,
      name: give_to,
      date:
        response?.status === "approved"
          ? response?.approved_or_rejected_at
          : response?.created_at,
      content: response?.message,
      url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${response?.to_user.id}`,
      icon: {
        original: "",
        large: "",
        medium: user?.user_image,
        small: ""
      },
      point: {
        total: response?.points,
        pointAddition: false,
        state
      },
      unread: response?.has_read === false && state !== "give" ? true : false
    };

    LocalStorage.setItem(
      "messageCardDetails",
      JSON.stringify(messageArticleDetail)
    );
  }

  get approvedLabel() {
    const { approved } = this.giveData;
    if (typeof approved === "undefined") return -1;
    return getApprovalStatusLabel(approved);
  }

  get title() {
    return this.giveData.title;
  }

  get giveId() {
    return this.giveData.give_details.give_id;
  }

  get giveDetails() {
    return this.giveData.give_details;
  }

  get image() {
    return this.giveData.give_details.image;
  }

  get message() {
    return this.giveData.give_details.message;
  }

  get approved() {
    return this.giveData.approved;
  }
  get point() {
    return this.giveData.point;
  }
  get userImageSize() {
    const { isSpScreenWidth } = globals;
    return isSpScreenWidth ? 72 : 138;
  }
  get approvalEnabled() {
    return auth.user.thanks_point_approval_enabled;
  }
  get messsageThreadEnabled() {
    return auth.user.thread_enabled && this.statusCode === 20;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }
}
</script>
<style>
  .p-badge {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .p-badge__icon {
    width: 38px;
    height: 38px;
    object-fit: contain;
    margin-right: 0.5rem;
  }

  .p-badge__name {
    font-size: 14px;
  }
</style>
